import { render } from "./OfferHistory.vue?vue&type=template&id=077cdfb0"
import script from "./OfferHistory.vue?vue&type=script&lang=js"
export * from "./OfferHistory.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__